import { Pipe, PipeTransform } from '@angular/core';

import { CompanyLanguage } from '@ninety/mobile/platform/api';

import { NinetyNotification } from '../models/ninety-notification.model';
import { NotificationItemType } from '../models/notification-item-type';
import { NotificationReason } from '../models/notification-reason';

@Pipe({
  name: 'notificationTitle',
})
export class NotificationTitlePipe implements PipeTransform {
  transform(notification: NinetyNotification, language: CompanyLanguage | null): string {
    if (!notification) return '';

    const itemName = this.getItemName(notification.itemType, language);
    const article = this.indefiniteArticle(itemName);
    const actionText = this.getActionText(notification.reason, article, itemName);

    return `<span class="terra-body-bold">${notification.createdByUserName}</span> ${actionText}`;
  }

  private getActionText(reason: NotificationReason, article: string, item: string): string {
    switch (reason) {
      case NotificationReason.assignment:
        return `assigned you ${article} ${item}`;
      case NotificationReason.comment:
        return `commented on ${article} ${item}`;
      case NotificationReason.mention:
        return 'mentioned you in a comment';
      case NotificationReason.itemMention:
        return `mentioned you in ${article} ${item}`;
      case NotificationReason.itemSent:
        return `sent ${article} ${item}`;
      default:
        return `updated your ${item}`;
    }
  }

  private getItemName(itemType: NotificationItemType, language: CompanyLanguage | null): string {
    switch (itemType) {
      case NotificationItemType.rock:
        return language?.rock?.item ?? 'Rock';
      case NotificationItemType.milestone:
        return language?.milestone?.item ?? 'Milestone';
      case NotificationItemType.todo:
        return language?.todo?.item ?? 'To-Do';
      case NotificationItemType.shortTermIssue:
      case NotificationItemType.longTermIssue:
        return language?.issue?.item ?? 'Issue';
      case NotificationItemType.headline:
        return language?.headline?.item ?? 'Headline';
      case NotificationItemType.cascadingMessage:
        return language?.cascadingMessage?.item ?? 'Cascading Message';
      default:
        return 'item';
    }
  }

  private indefiniteArticle(word: string): string {
    return /^[aeiou]/i.test(word) ? 'an' : 'a';
  }
}
